import { gql } from '@efficiently/client-core-graphql-models';

export const GET_CONTENT_FOLDER_COUNTS = gql(`
	query GetContentFolderCounts($projectId: String, $folderIds: [String!]!) {
		contentFolderCounts(projectId: $projectId, folderIds: $folderIds) {
			alias
			count
		}
	}
`);
